import { useTranslation } from 'react-i18next';
import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { CircleAlert } from 'lucide-react';
import { Button } from '@/shared/ui/button';

/** Rendered when a route throws or a lazy chunk fails to load. */
export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : undefined;

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="bg-destructive/10 text-destructive flex size-12 items-center justify-center rounded-full">
        <CircleAlert className="size-6" />
      </div>

      <div className="space-y-1">
        <h1 className="text-lg font-semibold">{t('common.somethingWentWrong')}</h1>
        <p className="text-muted-foreground max-w-md text-sm">{t('common.tryAgain')}</p>
        {detail ? (
          <p className="text-muted-foreground/80 max-w-md font-mono text-xs break-words">
            {detail}
          </p>
        ) : null}
      </div>

      <div className="flex gap-2">
        <Button variant="outline" onClick={() => window.location.reload()}>
          {t('common.retry')}
        </Button>
        <Button asChild>
          <Link to="/dashboard">{t('nav.dashboard')}</Link>
        </Button>
      </div>
    </div>
  );
}
